import { Kind, } from 'graphql';
import { DataTypeConfigU } from '../DateTypeConfig/DataTypeConfig';
import { DataTypeConfigUtils } from '../DateTypeConfig/DataTypeConfig.utils';
const getVariableDefinitinosFromDocumentNode = (documentNode) => {
    const queryDefinition = documentNode.definitions[0].kind === 'OperationDefinition'
        ? documentNode.definitions[0]
        : null;
    if (!queryDefinition) {
        throw new Error('Query definition not found');
    }
    const variableDefintions = queryDefinition.variableDefinitions ?? [];
    return variableDefintions;
};
const convertVariableTypeToDataTypeConfig = (typeNode, baseDataTypeConfigs, queryDataType) => {
    const isNullable = typeNode.kind !== Kind.NON_NULL_TYPE;
    const liftedType = isNullable ? typeNode : typeNode.type;
    if (liftedType.kind === Kind.LIST_TYPE) {
        return DataTypeConfigU.createListDataTypeConfig({
            isNullable,
            ofType: convertVariableTypeToDataTypeConfig(liftedType.type, baseDataTypeConfigs, queryDataType),
        });
    }
    if (liftedType.kind === Kind.NAMED_TYPE) {
        const dataTypeConfig = DataTypeConfigUtils.find([
            ['typeName', liftedType.name.value],
        ])(baseDataTypeConfigs);
        if (!dataTypeConfig) {
            throw new Error(`Data type config not found for ${liftedType.name.value}`);
        }
        return dataTypeConfig;
    }
    throw new Error(`Unsupported type node kind: ${liftedType}`);
};
const convertGraphQLConstValueToRealValue = (defaultValue) => {
    if (!defaultValue) {
        return undefined;
    }
    switch (defaultValue.kind) {
        case Kind.STRING:
        case Kind.BOOLEAN:
        case Kind.ENUM:
            return defaultValue.value;
        case Kind.INT:
            return parseInt(defaultValue.value);
        case Kind.FLOAT:
            return parseFloat(defaultValue.value);
        case Kind.NULL:
            return null;
        case Kind.LIST:
            return defaultValue.values.map(convertGraphQLConstValueToRealValue);
        case Kind.OBJECT:
            return defaultValue.fields.map(field => ({
                [field.name.value]: convertGraphQLConstValueToRealValue(field.value),
            }));
        default:
            throw new Error(`Unsupported const value kind: ${defaultValue}`);
    }
};
const convertGraphQLVariableDefinitionToInputValueDataTypeConfig = (variableDefinition, baseDataTypeConfigs, queryDataType) => {
    const key = variableDefinition.variable.name.value;
    const defaultValue = convertGraphQLConstValueToRealValue(variableDefinition.defaultValue);
    const ofType = convertVariableTypeToDataTypeConfig(variableDefinition.type, baseDataTypeConfigs, queryDataType);
    const isNullable = variableDefinition.type.kind !== Kind.NON_NULL_TYPE;
    return DataTypeConfigU.createInputValueDataTypeConfig({
        key,
        defaultValue,
        isNullable,
        ofType,
        state: {
            value: defaultValue,
        },
    });
};
const convertSchemaDirectiveToDirectiveConfig = (directiveNode) => {
    return {
        name: directiveNode.name.value,
        arguments: directiveNode.arguments?.reduce((acc, argument) => {
            acc[argument.name.value] = convertGraphQLConstValueToRealValue(argument.value);
            return acc;
        }, {}) ?? {},
    };
};
export const getQueryDefinitionVariables = (documentNode, baseDataTypeConfigs, queryDataType) => {
    const variableDefintions = getVariableDefinitinosFromDocumentNode(documentNode);
    return variableDefintions.map(variableDefinition => convertGraphQLVariableDefinitionToInputValueDataTypeConfig(variableDefinition, baseDataTypeConfigs, queryDataType));
};
export const GraphQLUtils = {
    getQueryDefinitionVariables,
    convertSchemaDirectiveToDirectiveConfig,
};
//# sourceMappingURL=graphql-utils.js.map